export class StartingEvent {
    constructor({ startingDate }) {
        this.name = 'starting';
        this.startingDate = startingDate;
    }
    get data() {
        return {
            startingDate: this.startingDate,
        };
    }
}
